module.exports = __webpack_public_path__ + "img/smLogo.ef30311f.svg";